
// ****************************** Import CSS ******************************** //

import "./index.css";

// ****************************** Import Images ******************************** //

import "./assets/logos/asattc-logo-purple.png";

//*** ASATTC Spinner Image ***//
import "./assets/asattc-round-favicon/asattc-round-favicon.png";

//*** ASATTC Nine Squares ***//
import "./assets/asattc-images/asattc-15-square-hero.jpg";
import "./assets/asattc-images/asattc-nine-square.jpg";

//*** Sponsor Logos ***//
import "./assets/sponsor-logos/home-depot-logo.jpg";
import "./assets/sponsor-logos/ila-logo-local-1414.png";
import "./assets/sponsor-logos/kia-logo.png";

//*** General Icons ***//
import "./assets/general-icons/spoon-plate-knife.png";
import "./assets/general-icons/covered-serving-tray.png";
import "./assets/general-icons/hand-lifting-heart.png";
import "./assets/general-icons/tell-others.png";

//*** Flyers ***//
import "./assets/asattc-flyers/asattc-i-is-we-05-2025.jpg";
import "./assets/asattc-flyers/asattc-zunzi-flyer-coming-soon.jpg";
import "./assets/asattc-flyers/asattc-battle-of-wings-fundraiser-04-2024.jpg";

// **************************** Add Top Nav & Footer ************************** //

import './nav-header-footer/nav-header-footer.js';
import './nav-header-footer/nav-header-footer.css';

// ******************** Add Homepage Announcement Banner ******************** //

import './homepage-banners/meal-prep-banner/meal-prep-banner.js';
import { homepageBanner } from './homepage-banners/meal-prep-banner/meal-prep-banner.js';

// **************************** Flyer Popup Modal ************************** //

import '/src/popups/flyer-popup.js';
import '/src/popups/flyer-popup.css';

// ************ Add Email Signup *************** //

import './nav-header-footer/email-contact-events.js';

// **************************** Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("spinner").style.display = "block";
  setTimeout(removeSpinner, 1000);
});

function removeSpinner(){
  $( "#spinner" ).fadeOut(100, function() {
    $( "#spinner" ).remove();
  });
}

// **************************** Media Queries ****************************** //

function heroMediaQueries() {

  const mobileQuery = window.matchMedia('(max-width: 767px)');

  if (mobileQuery.matches) {

    document.getElementById("heroImage").src="asattc-nine-square.jpg";
  }
}

heroMediaQueries()


// **************** Remove Navigation Border If Homepage Banner ****************** //

window.addEventListener('load', (event) => {
  
    console.log("All files are fully loaded!");

    const menuNavbar = document.getElementById("navbar");
    
    if (homepageBanner == 1) {
      menuNavbar.style.border = 'none';
    }
});



